/**
 * Convert a file:// URI to an absolute filesystem path.
 *
 * Handles the formats seen in practice across iOS, Android, and web:
 *   file:///absolute/path  → /absolute/path   (RFC 8089, most common)
 *   file://absolute/path   → /absolute/path   (missing slash — Android camera libs)
 *   file:/absolute/path    → /absolute/path   (single slash variant)
 *
 * Throws if the input doesn't start with file: or if the result isn't an absolute path.
 */
export const fileUriToPath = (uri: string): string => {
  if (!uri.startsWith('file:')) throw new Error(`Expected a file: URI, got: ${uri}`);
  // Strip the scheme and any number of leading slashes, then re-add exactly one
  const afterScheme = uri.slice('file:'.length).replace(/^\/+/, '');
  const path = '/' + afterScheme;
  return path;
};

/**
 * Convert an absolute filesystem path to a file:// URI (RFC 8089).
 *   /absolute/path → file:///absolute/path
 */
export const pathToFileUri = (path: string): string => {
  if (!path.startsWith('/')) throw new Error(`Expected an absolute path starting with /, got: ${path}`);
  return `file://${path}`;
};
